export default __webpack_public_path__ + "static/media/Cody_Foster.98ebbe97.webp";